import VistaBascula from "@/views/VistaBascula.vue";

const bascula = {
  path: "/app/bascula",
  name: "bascula",
  component: VistaBascula,
};

export default bascula;
